import DOMPurify from 'dompurify';

/**
 * SafeHTML component - sanitizes HTML before rendering
 * Replaces dangerouslySetInnerHTML with safe alternative
 */
const SafeHTML = ({ html, className = '', allowedTags = [] }) => {
	// Default allowed tags for basic formatting
	const defaultConfig = {
		ALLOWED_TAGS: ['br', 'p', 'strong', 'em', 'b', 'i', 'u', ...allowedTags],
		ALLOWED_ATTR: []
	};

	const sanitizedHTML = DOMPurify.sanitize(html, defaultConfig);

	return (
		<div
			className={className}
			dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
		/>
	);
};

export default SafeHTML;
